import { render, staticRenderFns } from "./PublicationAttachmentList.vue?vue&type=template&id=c206fc50"
import script from "./PublicationAttachmentList.vue?vue&type=script&lang=js"
export * from "./PublicationAttachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports